import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { mainPageQueries } from '@/services/mainPage/mainPage.queries';

export const useMainPageGroupDetail = (groupId: string) => {
  const { data, isFetched, isLoading } = useQuery({
    ...mainPageQueries.detail({ groupId }),
    enabled: !!groupId,
  });

  return {
    mainPageGroupDetail: data?.data[0],
    isFetched,
    isLoading,
  };
};
